import React from 'react'
import './Services.css'
import { FaRegHandPointRight } from 'react-icons/fa'



const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>
          <ul className='service__list'>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I Make Most Attractive Design.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I Provide Unique UI.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I build sooth UX web site.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I give fantastic feedback by UI/UX design. </p>
            </li>
          </ul>
        </article>
        {/* End of UI/UX */}

        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className='service__list'>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>React functional component and fully responsive website.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>Complete CRUD operation is shown.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p> Google and email signed in using Firebase authentication</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>The payment gateway implements.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p> In both admin & user panels for easy access and control.</p>
            </li>
          </ul>
        </article>
        {/* End of web */}

        <article className="service">
          <div className="service__head">
            <h3>Content Creation</h3>
          </div>
          <ul className='service__list'>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>This site I come very short time.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I Provide Unique Content.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I build sooth and very smart content.</p>
            </li>
            <li>
              <FaRegHandPointRight className='service__list-icon' />
              <p>I give fantastic feedback for content.</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default Services